import {GetVisitsOverviewUseCase} from '../useCases/GetVisitsOverviewUseCase';
import {GetVisitsListUseCase} from '../useCases/GetVisitsListUseCase';
import {GetVisitDetailsUseCase} from '../useCases/GetVisitDetailsUseCase';
import {GetVisitTrendsUseCase} from '../useCases/GetVisitTrendsUseCase';
// ManageVisitUseCase removed - management functionality not needed in dashboard
// GenerateVisitReportUseCase removed - export functionality not needed in dashboard
// CreateVisitUseCase removed - visits are created from mobile app
// UpdateProductQuantityUseCase removed - quantity update functionality not needed in dashboard
// AddVisitImageUseCase removed - image functionality not needed in dashboard
// CompleteVisitUseCase removed - complete visit functionality not needed in dashboard
import {GetStoreVisitHistoryUseCase} from '../useCases/GetStoreVisitHistoryUseCase';
import {GetStoreApprovedVisitsUseCase} from '../useCases/GetStoreActiveVisitUseCase';
import {DeleteAllActiveVisitsUseCase} from '../useCases/DeleteAllActiveVisitsUseCase';

/**
 * Visits Factory - Singleton Pattern
 * يمنع تكرار إنشاء instances للـ use cases
 * ويضمن استخدام نفس الـ instance في جميع أنحاء التطبيق
 */
class VisitsFactoryClass {
  private static instance: VisitsFactoryClass;

  // Use case instances
  private getVisitsOverviewUseCase: GetVisitsOverviewUseCase | null = null;
  private getVisitsListUseCase: GetVisitsListUseCase | null = null;
  private getVisitDetailsUseCase: GetVisitDetailsUseCase | null = null;
  private getVisitTrendsUseCase: GetVisitTrendsUseCase | null = null;
  // manageVisitUseCase removed - management functionality not needed in dashboard
  // generateVisitReportUseCase removed - export functionality not needed in dashboard
  // createVisitUseCase removed - visits are created from mobile app
  // updateProductQuantityUseCase removed - quantity update functionality not needed in dashboard
  // addVisitImageUseCase removed - image functionality not needed in dashboard
  // completeVisitUseCase removed - complete visit functionality not needed in dashboard
  private getStoreVisitHistoryUseCase: GetStoreVisitHistoryUseCase | null = null;
  private getStoreApprovedVisitsUseCase: GetStoreApprovedVisitsUseCase | null = null;
  private deleteAllActiveVisitsUseCase: DeleteAllActiveVisitsUseCase | null = null;

  private constructor () {}

  public static getInstance (): VisitsFactoryClass {
    if (!VisitsFactoryClass.instance) {
      VisitsFactoryClass.instance = new VisitsFactoryClass();
    }
    return VisitsFactoryClass.instance;
  }

  // Get Visits Overview Use Case
  public createGetVisitsOverviewUseCase (): GetVisitsOverviewUseCase {
    if (!this.getVisitsOverviewUseCase) {
      this.getVisitsOverviewUseCase = new GetVisitsOverviewUseCase();
    }
    return this.getVisitsOverviewUseCase;
  }

  // Get Visits List Use Case
  public createGetVisitsListUseCase (): GetVisitsListUseCase {
    if (!this.getVisitsListUseCase) {
      this.getVisitsListUseCase = new GetVisitsListUseCase();
    }
    return this.getVisitsListUseCase;
  }

  // Get Visit Details Use Case
  public createGetVisitDetailsUseCase (): GetVisitDetailsUseCase {
    if (!this.getVisitDetailsUseCase) {
      this.getVisitDetailsUseCase = new GetVisitDetailsUseCase();
    }
    return this.getVisitDetailsUseCase;
  }

  // Get Visit Trends Use Case
  public createGetVisitTrendsUseCase (): GetVisitTrendsUseCase {
    if (!this.getVisitTrendsUseCase) {
      this.getVisitTrendsUseCase = new GetVisitTrendsUseCase();
    }
    return this.getVisitTrendsUseCase;
  }

  // Manage Visit Use Case removed - management functionality not needed in dashboard

  // Generate Visit Report Use Case removed - export functionality not needed in dashboard

  // Create Visit Use Case removed - visits are created from mobile app

  // Update Product Quantity Use Case removed - quantity update functionality not needed in dashboard

  // Add Visit Image Use Case removed - image functionality not needed in dashboard

  // Complete Visit Use Case removed - complete visit functionality not needed in dashboard

  // Get Store Visit History Use Case
  public createGetStoreVisitHistoryUseCase (): GetStoreVisitHistoryUseCase {
    if (!this.getStoreVisitHistoryUseCase) {
      this.getStoreVisitHistoryUseCase = new GetStoreVisitHistoryUseCase();
    }
    return this.getStoreVisitHistoryUseCase;
  }

  // Get Store Approved Visits Use Case
  public createGetStoreApprovedVisitsUseCase (): GetStoreApprovedVisitsUseCase {
    if (!this.getStoreApprovedVisitsUseCase) {
      this.getStoreApprovedVisitsUseCase = new GetStoreApprovedVisitsUseCase();
    }
    return this.getStoreApprovedVisitsUseCase;
  }

  // Delete All Active Visits Use Case
  public createDeleteAllActiveVisitsUseCase (): DeleteAllActiveVisitsUseCase {
    if (!this.deleteAllActiveVisitsUseCase) {
      this.deleteAllActiveVisitsUseCase = new DeleteAllActiveVisitsUseCase();
    }
    return this.deleteAllActiveVisitsUseCase;
  }

  // Reset all instances (useful for testing)
  public reset (): void {
    this.getVisitsOverviewUseCase = null;
    this.getVisitsListUseCase = null;
    this.getVisitDetailsUseCase = null;
    this.getVisitTrendsUseCase = null;
    // manageVisitUseCase removed
    // generateVisitReportUseCase removed
    // createVisitUseCase removed
    // updateProductQuantityUseCase removed
    // addVisitImageUseCase removed
    // completeVisitUseCase removed
    this.getStoreVisitHistoryUseCase = null;
    this.getStoreApprovedVisitsUseCase = null;
    this.deleteAllActiveVisitsUseCase = null;
  }
}

// Export singleton instance
export const VisitsFactory = VisitsFactoryClass.getInstance();
